import { render } from "./IotCardBody.vue?vue&type=template&id=fd287c82&scoped=true"
import script from "./IotCardBody.vue?vue&type=script&lang=js"
export * from "./IotCardBody.vue?vue&type=script&lang=js"

import "./IotCardBody.vue?vue&type=style&index=0&id=fd287c82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd287c82"]])

export default __exports__